const raw = (process.env.REACT_APP_BACKEND_URL || '').trim();
/** URL del backend sin barra final; vacío si no se definió REACT_APP_BACKEND_URL en el build. */
export const BACKEND_URL = raw.replace(/\/$/, '');

/**
 * Base de la API (`/api/...`).
 * - Con `REACT_APP_BACKEND_URL`: URL absoluta (el backend debe permitir CORS desde el front).
 * - Sin ella: mismo origen `/api` — en `npm start`, Craco reenvía a `127.0.0.1:8000`; en Vercel usa
 *   `middleware.js` + variable de entorno `MUNIBUS_BACKEND_URL` (solo servidor).
 */
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';
